import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { HardDrive } from 'lucide-react'
import { SourcesScreen } from '@/screens/connect/SCR-034-sources'

const flag = z.preprocess(v => v === true || v === 1 || v === '1' || v === 'true', z.boolean())

export const Route = createFileRoute('/_app/connect/sources')({
  staticData: { screen: { id: 'SCR-034', title: 'Sources', group: 'Connect', perm: 'connector.manage', order: 2, description: 'Systems ESM learns from: signed webhooks, web pages and feeds. Each writes into one scope, as its owner.', icon: HardDrive } },
  validateSearch: z.object({
    status: z.enum(['active', 'paused']).optional().catch(undefined),
    kind: z.enum(['webhook', 'url', 'rss']).optional().catch(undefined),
    new: flag.optional().catch(undefined),
  }),
  component: SourcesScreen,
})
